import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=1dc86408&scoped=true&"
import script from "./Secret.vue?vue&type=script&lang=js&"
export * from "./Secret.vue?vue&type=script&lang=js&"
import style0 from "./Secret.vue?vue&type=style&index=0&id=1dc86408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc86408",
  null
  
)

export default component.exports